import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as PanicReducer from './panic.reducer';

export const selectPanicState = createFeatureSelector<PanicReducer.PanicState>(PanicReducer.panicFeatureKey);
export const getPanicMessage = createSelector(selectPanicState, (state: PanicReducer.PanicState) => state.message);
